import { render } from "./SnowLoad.vue?vue&type=template&id=a70ab632"
import script from "./SnowLoad.vue?vue&type=script&lang=js"
export * from "./SnowLoad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__